import React, {ReactNode} from 'react';
import {r} from "@/utils/responsive";

interface ShortcutReforgeProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: ReactNode
    isLarge?: boolean
    isMedium?: boolean
    shadowColor?: string
}

const ShortcutReforge: React.FC<ShortcutReforgeProps> = ({
                                                             className,
                                                             children,
                                                             isLarge = false,
                                                             isMedium = false,
                                                             shadowColor = '#9CB7FF',
                                                             ...props
                                                         }) => {
    return (
        <div
            {...props}
            style={{
                position: 'relative',
                height: r.vmax(32),
                width: isLarge ? r.vmax(104) : isMedium ? r.vmax(70) : 'auto',
                boxShadow: `0 max(${r.vmax(2)}, 2px) 0 ${shadowColor}`,
                borderRadius: r.vmax(10),
                fontSize: r.vmax(18),
                lineHeight: r.vmax(24),
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: '#FFFFFF',
                background: 'transparent',
                padding: `0 ${r.vmax(8)}`,
            }}
        >
            <div style={{
                position: 'absolute',
                inset: 0,
                width: '100%',
                height: '100%',
                borderRadius: r.vmax(10),
                background: `linear-gradient(to bottom, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 1) 100%)`,
                zIndex: 1,
                opacity: .3,
            }}>
            </div>
            <div style={{
                position: 'absolute',
                inset: 0,
                width: '100%',
                height: '100%',
                borderRadius: r.vmax(10),
                zIndex: 2,
                border: `1px solid white`,
                maskImage: `linear-gradient(to bottom, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.12) 100%)`,
            }}>
            </div>
            <span style={{
                position: 'relative',
                zIndex: 3,
                textShadow: `0 ${r.vmax(4)} ${r.vmax(30)} #5282FF`
            }}>
            {children}
            </span>
        </div>
    );
};

export default ShortcutReforge;
